import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const resetPasswordReducer = createReducer<State, Actions>(initialState, {
  [actions.resetPassword.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.resetPassword.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.resetPassword.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.resetPassword.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default resetPasswordReducer;
